import * as React from 'react';
import { FelaComponent } from '@filou/core';
var Image = function (_a) {
    var src = _a.src;
    return (React.createElement(FelaComponent, { style: {
            overflow: 'hidden',
            height: 450,
            width: 'auto',
            background: "url(" + src + ") no-repeat center center",
            backgroundSize: 'cover'
        } }));
};
export default Image;
//# sourceMappingURL=index.js.map